<template>
    <div class="map-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        class="map"
      >
        <g v-for="state in states" :key="state.id">
          <!-- Caminho do estado -->
          <path
            :d="state.path"
            :fill="state.color"
            @mouseover="hoverState(state.id, $event)"
            @click="selectState(state.id)"
            class="state"
          />
          <circle
            v-if="state.cx && state.cy"
            :cx="state.cx"
            :cy="state.cy"
            r="12"
            fill="#d4e6f1"
            class="state-icon"
        />
          <text
            :x="state.labelX"
            :y="state.labelY"
            text-anchor="middle"
            class="state-label"
          >
            {{ state.id }}
          </text>
        </g>        
      </svg>
  
      <!-- Tooltip -->
      <!--
      <div v-if="hoveredState" class="tooltip" :style="{ top: tooltipY, left: tooltipX }">
        <strong>{{ hoveredState }}</strong>
      </div>
      -->
    </div>
  </template>
  
  <script>
  import { ref } from "vue";
  import { useRouter } from "vue-router";
  import systemData from "@/services/system.json";
  
  export default {
    name: "MapaBrazil",
    setup() {
      const router = useRouter();
      const states = systemData.statesSvg;
  
      const hoveredState = ref(null);
      const tooltipX = ref("0px");
      const tooltipY = ref("0px");
  
      const hoverState = (id, event) => {
        const state = states.find((s) => s.id === id);
        if (state) {
          hoveredState.value = state.name;
          state.color = "#aaaaaa";
          tooltipX.value = `${event.pageX}px`;
          tooltipY.value = `${event.pageY}px`;
        }
      };
   
      const selectState = (id) => {
        router.push(`/${id}`);
      };
  
      /*
      // Buscar a quantidade de anúncios
    const fetchAdsCount = async () => {
      try {
        const response = await axios.get("/api/ads-count");
        const adsData = response.data; // Suponha que a API retorne { stateId: count }
        
        states.value.forEach(state => {
          if (adsData[state.id]) {
            state.adsCount = adsData[state.id]; // Atribuir a quantidade de anúncios
          }
        });
      } catch (error) {
        console.error("Erro ao buscar dados de anúncios", error);
      }
    };

    onMounted(() => {
      fetchAdsCount();
    });
    */
      return {
        states,
        hoveredState,
        tooltipX,
        tooltipY,
        hoverState,
        selectState,
      };
    },
  };
</script>
  
<style scoped>
.map-container {
    text-align: center;
}
.map {
	font-size: 10px;
    color: #FFF;
}
.state {
    fill: #cccccc;
    transition: all 350ms linear;
    &:hover {
        fill: #C60210;
    }
}
	
.state-label {
    fill: #FFF;
    font-size: 0.8rem;
    pointer-events: none;
}

.state-icon {
    fill: #212529;
    pointer-events: none;
    &:hover {
        fill: #C60210;
    }
}
.tooltip {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 0.85rem;
    pointer-events: none;
    z-index: 10;
}
</style>
  